// Part of purchasePages, split by screen to keep files short; purchasePages.ts merges the parts.
export const en = {
  listCommon: {
    selectClientHint: 'Use the client switcher in the top bar.',
    searchStatus: 'Status',
    date: 'Date',
    dateFilter: {
      all: 'All dates',
      '30': 'Last 30 days',
      month: 'This month',
      quarter: 'This quarter',
      year: 'This year',
      '365': 'Last 12 months',
    },
    paymentMethod: {
      bank_transfer: 'Bank transfer',
      cheque: 'Cheque',
      cash: 'Cash',
      card: 'Credit card',
    },
  },
  table: {
    date: 'Date',
    type: 'Type',
    number: 'No.',
    payee: 'Payee',
    category: 'Category',
    dueDate: 'Due date',
    balance: 'Balance',
    total: 'Total',
    status: 'Status',
    action: 'Action',
    rowType: {
      bill: 'Bill',
      expense: 'Expense',
      debit_note: 'Debit note',
      purchase_order: 'Purchase order',
      vendor_payment: 'Bill payment',
    },
    transactions_one: '{{count}} transaction',
    transactions_other: '{{count}} transactions',
    approvedToast: {
      bill: 'Bill {{number}} approved and posted.',
      expense: 'Expense {{number}} approved and posted.',
      debit_note: 'Debit note {{number}} approved and posted.',
      purchase_order: 'Purchase order {{number}} approved and posted.',
    },
    view: 'View',
    approve: 'Approve',
    copyToBill: 'Copy to bill',
    makePayment: 'Make payment',
    apply: 'Apply',
  },
  bills: {
    title: 'Bills',
    payBills: 'Pay bills',
    newBill: 'New bill',
    chips: {
      all: 'All',
      draft: 'Draft',
      unpaid: 'Unpaid',
      overdue: 'Overdue',
      not_due: 'Not due yet',
      partially_paid: 'Partially paid',
      paid: 'Paid',
      void: 'Void',
    },
    searchPlaceholder: 'Search by vendor, bill no. or memo',
    searchLabel: 'Search bills',
    loadError: 'Could not load bills',
    noMatch: 'No bills match these filters',
    empty: 'No bills yet',
  },
  expensesHome: {
    title: 'Expenses',
    newTransaction: 'New transaction',
    menuExpense: 'Expense',
    menuBill: 'Bill',
    menuPayBills: 'Pay bills',
    menuDebitNote: 'Debit note',
    types: {
      all: 'All transactions',
      bill: 'Bills',
      expense: 'Expenses',
      vendor_payment: 'Bill payments',
      debit_note: 'Debit notes',
    },
    statuses: {
      all: 'All statuses',
      open: 'Open',
      overdue: 'Overdue',
      draft: 'Draft',
      paid: 'Paid / closed',
      void: 'Void',
    },
    typeLabel: 'Type',
    payeeLabel: 'Payee',
    allPayees: 'All payees',
    noPayee: 'No payee',
    searchPlaceholder: 'Search by payee, no., category or memo',
    searchLabel: 'Search expenses',
    loadError: 'Could not load expenses',
    noMatch: 'No transactions match these filters',
    empty: 'No expenses yet',
    emptyHint: 'Bills, expenses, bill payments and debit notes appear here.',
  },
  purchaseOrders: {
    title: 'Purchase orders',
    description:
      'What you have ordered from vendors. Bills receive them; nothing is posted until the bill.',
    newPurchaseOrder: 'New purchase order',
    chips: { open: 'Open', closed: 'Closed', all: 'All' },
    searchPlaceholder: 'Search by vendor, PO no. or memo',
    searchLabel: 'Search purchase orders',
    loadError: 'Could not load purchase orders',
    noOpen: 'No open purchase orders',
    noneHere: 'No purchase orders here',
  },
  payBills: {
    title: 'Pay bills',
    saveShortcut: 'Ctrl+Alt+S',
    unsavedConfirm: 'You have unsaved changes. Leave without saving?',
    recorded_one: '{{count}} bill payment recorded.',
    recorded_other: '{{count}} bill payments recorded.',
    recordedWithTotal_one: '{{count}} bill payment recorded ({{amount}}).',
    recordedWithTotal_other: '{{count}} bill payments recorded ({{amount}}).',
    creditApplied: 'Vendor credit of {{amount}} applied.',
    view: 'View',
    chooseAccount: 'Choose the payment account.',
    chooseBill: 'Choose at least one bill.',
    clearPayments: 'Clear payments',
    paymentAccount: 'Payment account *',
    balance: 'Balance',
    paymentDate: 'Payment date *',
    paymentMethod: 'Payment method',
    startingReference: 'Starting cheque / ref no.',
    totalPaymentAmount: 'Total payment amount',
    severalCurrencies: 'Several currencies',
    vendor: 'Vendor',
    allVendors: 'All vendors',
    overdueOnly: 'Overdue only',
    noMatch: 'No open bills match these filters.',
    noOpenBills: 'No open bills.',
    openBills: 'Open bills',
    payee: 'Payee',
    refNo: 'Ref no.',
    dueDate: 'Due date',
    currency: 'Currency',
    openBalance: 'Open balance',
    creditAppliedColumn: 'Credit applied',
    payment: 'Payment',
    totalAmount: 'Total amount',
    payBill: 'Pay {{number}}',
    journalEntry: 'Journal entry {{number}}',
    overdue: '(overdue)',
    creditAppliedTo: 'Credit applied to {{number}}',
    paymentFor: 'Payment for {{number}}',
    selected_one: '{{count}} of {{total}} bills selected',
    selected_other: '{{count}} of {{total}} bills selected',
    footnote:
      'One bill payment is recorded per vendor. Vendor credit comes from debit notes and earlier unapplied payments, oldest first. Shortcuts: Ctrl+Alt+S save and close · Ctrl+Alt+D save and new · Ctrl+Alt+X close.',
  },
  payment: {
    voidedToast: 'Bill payment {{number}} voided.',
    notFound: 'Bill payment not found',
    title: 'Bill payment {{number}}',
    transactionJournal: 'Transaction journal',
    void: 'Void',
    isVoid:
      'This bill payment is void. Its posting was reversed and the bills it paid are open again.',
    isVoidWithReason:
      'This bill payment is void: {{reason}}. Its posting was reversed and the bills it paid are open again.',
    payee: 'Payee',
    paymentDate: 'Payment date',
    paymentAccount: 'Payment account',
    paymentMethod: 'Payment method',
    reference: 'Cheque / ref no.',
    amountPaid: 'Amount paid',
    exchangeRate: 'Exchange rate',
    amountPaidHome: 'Amount paid in {{currency}}',
    unapplied: 'Unapplied (credit with the vendor)',
    memo: 'Memo',
    billsPaid: 'Bills paid',
    journalEntry: 'Journal entry {{number}}',
    bill: 'Bill {{number}}',
    exchangeLoss: 'Exchange loss {{amount}}',
    exchangeGain: 'Exchange gain {{amount}}',
    totalApplied: 'Total applied',
    notApplied: 'Not applied to any bill.',
    voidTitle: 'Void bill payment {{number}}',
    voidDescription:
      'Voiding posts a reversing entry and reopens the bills this payment settled. This cannot be undone.',
  },
};

export const ar = {
  listCommon: {
    selectClientHint: 'استخدم أداة تبديل العميل في الشريط العلوي.',
    searchStatus: 'الحالة',
    date: 'التاريخ',
    dateFilter: {
      all: 'كل التواريخ',
      '30': 'آخر 30 يوماً',
      month: 'هذا الشهر',
      quarter: 'هذا الربع',
      year: 'هذه السنة',
      '365': 'آخر 12 شهراً',
    },
    paymentMethod: {
      bank_transfer: 'تحويل بنكي',
      cheque: 'شيك',
      cash: 'نقداً',
      card: 'بطاقة ائتمان',
    },
  },
  table: {
    date: 'التاريخ',
    type: 'النوع',
    number: 'الرقم',
    payee: 'المستفيد',
    category: 'الفئة',
    dueDate: 'تاريخ الاستحقاق',
    balance: 'الرصيد',
    total: 'الإجمالي',
    status: 'الحالة',
    action: 'الإجراء',
    rowType: {
      bill: 'فاتورة مورد',
      expense: 'مصروف',
      debit_note: 'إشعار مدين',
      purchase_order: 'أمر شراء',
      vendor_payment: 'سداد فاتورة مورد',
    },
    transactions_zero: 'لا توجد معاملات',
    transactions_one: 'معاملة واحدة',
    transactions_two: 'معاملتان',
    transactions_few: '{{count}} معاملات',
    transactions_many: '{{count}} معاملةً',
    transactions_other: '{{count}} معاملة',
    approvedToast: {
      bill: 'تم اعتماد فاتورة المورد {{number}} وترحيلها.',
      expense: 'تم اعتماد المصروف {{number}} وترحيله.',
      debit_note: 'تم اعتماد الإشعار المدين {{number}} وترحيله.',
      purchase_order: 'تم اعتماد أمر الشراء {{number}} وترحيله.',
    },
    view: 'عرض',
    approve: 'اعتماد',
    copyToBill: 'نسخ إلى فاتورة مورد',
    makePayment: 'سداد',
    apply: 'تطبيق',
  },
  bills: {
    title: 'فواتير الموردين',
    payBills: 'سداد فواتير الموردين',
    newBill: 'فاتورة مورد جديدة',
    chips: {
      all: 'الكل',
      draft: 'مسودة',
      unpaid: 'غير مدفوعة',
      overdue: 'متأخرة',
      not_due: 'غير مستحقة بعد',
      partially_paid: 'مدفوعة جزئياً',
      paid: 'مدفوعة',
      void: 'ملغاة',
    },
    searchPlaceholder: 'ابحث باسم المورد أو رقم الفاتورة أو المذكرة',
    searchLabel: 'البحث في فواتير الموردين',
    loadError: 'تعذّر تحميل فواتير الموردين',
    noMatch: 'لا توجد فواتير موردين تطابق عوامل التصفية هذه',
    empty: 'لا توجد فواتير موردين بعد',
  },
  expensesHome: {
    title: 'المصروفات',
    newTransaction: 'معاملة جديدة',
    menuExpense: 'مصروف',
    menuBill: 'فاتورة مورد',
    menuPayBills: 'سداد فواتير الموردين',
    menuDebitNote: 'إشعار مدين',
    types: {
      all: 'كل المعاملات',
      bill: 'فواتير الموردين',
      expense: 'المصروفات',
      vendor_payment: 'مدفوعات فواتير الموردين',
      debit_note: 'الإشعارات المدينة',
    },
    statuses: {
      all: 'كل الحالات',
      open: 'مفتوحة',
      overdue: 'متأخرة',
      draft: 'مسودة',
      paid: 'مدفوعة / مغلقة',
      void: 'ملغاة',
    },
    typeLabel: 'النوع',
    payeeLabel: 'المستفيد',
    allPayees: 'كل المستفيدين',
    noPayee: 'بدون مستفيد',
    searchPlaceholder: 'ابحث بالمستفيد أو الرقم أو الفئة أو المذكرة',
    searchLabel: 'البحث في المصروفات',
    loadError: 'تعذّر تحميل المصروفات',
    noMatch: 'لا توجد معاملات تطابق عوامل التصفية هذه',
    empty: 'لا توجد مصروفات بعد',
    emptyHint: 'تظهر هنا فواتير الموردين والمصروفات ومدفوعات الفواتير والإشعارات المدينة.',
  },
  purchaseOrders: {
    title: 'أوامر الشراء',
    description:
      'ما طلبته من الموردين. تستلمها فواتير الموردين، ولا يُرحَّل شيء حتى تُسجَّل الفاتورة.',
    newPurchaseOrder: 'أمر شراء جديد',
    chips: { open: 'مفتوحة', closed: 'مغلقة', all: 'الكل' },
    searchPlaceholder: 'ابحث باسم المورد أو رقم أمر الشراء أو المذكرة',
    searchLabel: 'البحث في أوامر الشراء',
    loadError: 'تعذّر تحميل أوامر الشراء',
    noOpen: 'لا توجد أوامر شراء مفتوحة',
    noneHere: 'لا توجد أوامر شراء هنا',
  },
  payBills: {
    title: 'سداد فواتير الموردين',
    saveShortcut: 'Ctrl+Alt+S',
    unsavedConfirm: 'لديك تغييرات غير محفوظة. هل تريد المغادرة دون حفظ؟',
    recorded_zero: 'لم تُسجَّل أي دفعة.',
    recorded_one: 'تم تسجيل دفعة فاتورة واحدة.',
    recorded_two: 'تم تسجيل دفعتين.',
    recorded_few: 'تم تسجيل {{count}} دفعات.',
    recorded_many: 'تم تسجيل {{count}} دفعةً.',
    recorded_other: 'تم تسجيل {{count}} دفعة.',
    recordedWithTotal_zero: 'لم تُسجَّل أي دفعة ({{amount}}).',
    recordedWithTotal_one: 'تم تسجيل دفعة فاتورة واحدة ({{amount}}).',
    recordedWithTotal_two: 'تم تسجيل دفعتين ({{amount}}).',
    recordedWithTotal_few: 'تم تسجيل {{count}} دفعات ({{amount}}).',
    recordedWithTotal_many: 'تم تسجيل {{count}} دفعةً ({{amount}}).',
    recordedWithTotal_other: 'تم تسجيل {{count}} دفعة ({{amount}}).',
    creditApplied: 'تم تطبيق رصيد دائن لدى المورد بقيمة {{amount}}.',
    view: 'عرض',
    chooseAccount: 'اختر حساب الدفع.',
    chooseBill: 'اختر فاتورة مورد واحدة على الأقل.',
    clearPayments: 'مسح المدفوعات',
    paymentAccount: 'حساب الدفع *',
    balance: 'الرصيد',
    paymentDate: 'تاريخ الدفع *',
    paymentMethod: 'طريقة الدفع',
    startingReference: 'رقم الشيك / المرجع الأول',
    totalPaymentAmount: 'إجمالي مبلغ الدفع',
    severalCurrencies: 'عملات متعددة',
    vendor: 'المورد',
    allVendors: 'كل الموردين',
    overdueOnly: 'المتأخرة فقط',
    noMatch: 'لا توجد فواتير موردين مفتوحة تطابق عوامل التصفية هذه.',
    noOpenBills: 'لا توجد فواتير موردين مفتوحة.',
    openBills: 'فواتير الموردين المفتوحة',
    payee: 'المستفيد',
    refNo: 'رقم المرجع',
    dueDate: 'تاريخ الاستحقاق',
    currency: 'العملة',
    openBalance: 'الرصيد المفتوح',
    creditAppliedColumn: 'الرصيد الدائن المطبّق',
    payment: 'الدفعة',
    totalAmount: 'المبلغ الإجمالي',
    payBill: 'سداد {{number}}',
    journalEntry: 'قيد يومية {{number}}',
    overdue: '(متأخرة)',
    creditAppliedTo: 'الرصيد الدائن المطبّق على {{number}}',
    paymentFor: 'الدفعة عن {{number}}',
    selected_zero: 'لم تُحدَّد أي فاتورة من {{total}}',
    selected_one: 'تم تحديد فاتورة واحدة من {{total}}',
    selected_two: 'تم تحديد فاتورتين من {{total}}',
    selected_few: 'تم تحديد {{count}} فواتير من {{total}}',
    selected_many: 'تم تحديد {{count}} فاتورةً من {{total}}',
    selected_other: 'تم تحديد {{count}} فاتورة من {{total}}',
    footnote:
      'تُسجَّل دفعة واحدة لكل مورد. يأتي الرصيد الدائن لدى المورد من الإشعارات المدينة والمدفوعات السابقة غير المطبّقة، الأقدم أولاً. الاختصارات: Ctrl+Alt+S حفظ وإغلاق · Ctrl+Alt+D حفظ وجديد · Ctrl+Alt+X إغلاق.',
  },
  payment: {
    voidedToast: 'تم إلغاء سداد فاتورة المورد {{number}}.',
    notFound: 'لم يُعثر على سداد فاتورة المورد',
    title: 'سداد فاتورة مورد {{number}}',
    transactionJournal: 'قيد المعاملة',
    void: 'إلغاء',
    isVoid: 'هذه الدفعة ملغاة. تم عكس ترحيلها وأُعيد فتح فواتير الموردين التي سددتها.',
    isVoidWithReason:
      'هذه الدفعة ملغاة: {{reason}}. تم عكس ترحيلها وأُعيد فتح فواتير الموردين التي سددتها.',
    payee: 'المستفيد',
    paymentDate: 'تاريخ الدفع',
    paymentAccount: 'حساب الدفع',
    paymentMethod: 'طريقة الدفع',
    reference: 'رقم الشيك / المرجع',
    amountPaid: 'المبلغ المدفوع',
    exchangeRate: 'سعر الصرف',
    amountPaidHome: 'المبلغ المدفوع بعملة {{currency}}',
    unapplied: 'غير مطبّق (رصيد دائن لدى المورد)',
    memo: 'المذكرة',
    billsPaid: 'فواتير الموردين المسددة',
    journalEntry: 'قيد يومية {{number}}',
    bill: 'فاتورة مورد {{number}}',
    exchangeLoss: 'خسارة فرق صرف {{amount}}',
    exchangeGain: 'ربح فرق صرف {{amount}}',
    totalApplied: 'إجمالي المطبّق',
    notApplied: 'لم تُطبَّق على أي فاتورة مورد.',
    voidTitle: 'إلغاء سداد فاتورة المورد {{number}}',
    voidDescription:
      'يؤدي الإلغاء إلى ترحيل قيد عكسي وإعادة فتح فواتير الموردين التي سددتها هذه الدفعة. لا يمكن التراجع عن ذلك.',
  },
};
